module.exports = __webpack_public_path__ + "img/Job.8432dd89.svg";